import { useTranslation } from 'react-i18next';

import type { Classroom } from '@innovamat/ga-features';
import type { ClassCardOptions } from '../../../../components/class-card/class-card.options';

type Props = {
  openEditModal: (classroom: Classroom) => void;
  handleDeleteClassWithConfirmation: (classroom: Classroom) => void;
};

type CreateOptions = {
  createJourneyOptions: (classroom: Classroom) => ClassCardOptions;
};

function useSchoolJourneyCreateOptions({
  openEditModal,
  handleDeleteClassWithConfirmation,
}: Props): CreateOptions {
  const { t } = useTranslation();
  const createJourneyOptions = (classroom: Classroom) => {
    const options: ClassCardOptions = {
      edit: {
        text: t('common.edit'),
        onClick: () => {
          openEditModal(classroom);
        },
      },
    };

    // TODO move this condition to modules
    const isDeletedEnabled = classroom.numberOfStudents === 0;

    options.delete = {
      text: t('classrooms.delete-journey'),
      subtitle: !isDeletedEnabled
        ? t('my-classes.delete-journey.warning')
        : undefined,
      onClick: () => handleDeleteClassWithConfirmation(classroom),
      state: isDeletedEnabled ? 'active' : 'disabled',
    };
    return options;
  };

  return { createJourneyOptions };
}

export { useSchoolJourneyCreateOptions };
